<template>
    <div class="text-right">
        <div class="tou-top">
            <div class="head-top">
            <img class="returns" @click="returnTop" src="../../assets/guild/returnimg.png" alt="" />
            <p>{{ $t("roomParty.title") }}</p>
            </div>
        </div>
        <div class="head">
            <img class="head-img" src="../../assets/moveabout/fj/bg@3x.png" alt="">
            <div v-if="this.$i18n.locale == 'zh' || this.$i18n.locale == 'en' || this.$i18n.locale == 'tc'" class="title">
                <img src="../../assets/moveabout/fj/title@3x.png" alt="">
            </div>
            <div v-if="this.$i18n.locale == 'tr'" class="title"><img src="../../assets/moveabout/fj/title@33x.png" alt="">
            </div>
            <div v-if="this.$i18n.locale == 'ar'" class="title"><img src="../../assets/moveabout/fj/title@2x.png" alt="">
            </div>
            <div v-if="this.$i18n.locale == 'es'" class="title"><img src="../../assets/moveabout/fj/titxi.png" alt="">
            </div>
            <div v-if="!ruleAwardSta" class="title-left" @click="ruleAward">{{ $t('roomParty.rule_reward') }}</div>
            <div v-if="!previousPeriodSta" class="title-left1" @click="previousPeriod(1)">{{ $t('roomParty.last_week') }}
            </div>
            <div v-if="previousPeriodSta" class="title-left1" @click="previousPeriod(2)">
                <img class="back_img" src="../../assets/moveabout/fj/back@3x.png" alt="">
                <span>{{ $t('roomParty.back') }}</span>
            </div>

            <div v-if="!ruleAwardSta" class="head_btn">
                <div class="time_diamond" :class="activation == 1 ? 'activation_bg' : ''" @click="ruleAwardBtn(1)">
                    {{ $t('roomParty.time_rank') }}
                </div>
                <div class="time_diamond" :class="activation == 2 ? 'activation_bg' : ''" @click="ruleAwardBtn(2)">
                    {{ $t('roomParty.rich_rank') }}
                </div>
            </div>

            <div v-else class="head_btn">
                <div class="time_diamond" :class="activation == 1 ? 'activation_bg' : ''" @click="awardBtn(1)">
                    {{ $t('roomParty.reward') }}
                </div>
                <div class="time_diamond" :class="activation == 2 ? 'activation_bg' : ''" @click="awardBtn(2)">
                    {{ $t('roomParty.rule') }}
                </div>

            </div>
        </div>
        <div class="body">
            <div class="body-top">
                <div class="minbody" @scroll="pageScroll">
                    <div v-if="!ruleAwardSta">
                        <div v-if="previousPeriodSta" class="body_text">{{ $t('roomParty.last_week_rank') }}</div>

                        <div v-else class="time">
                            <span class="ft16">{{ $t('Eventtime') }}</span>
                            <div class="ft15" v-if="this.$i18n.locale == 'ar'">
                                KSA&nbsp;<span>{{ endTimeAr }}</span>&nbsp;<span>{{ endDate
                                }}</span>&nbsp;-&nbsp;KSA<span>{{ startTimeAr }}</span>&nbsp;<span>{{
    startDate }}</span></div>
                            <div v-else class="ft15"><span>{{ startTime }}</span> -- <span>{{ endTime }}</span></div>
                        </div>
                        <div v-for="(item, index) in userInfoData.list" :key="index">
                            <div class="tou" v-if="item.top == 1">
                                <div class="tou_img">
                                    <div class="tou_top1" @click="languageRoomBtn(item)">
                                        <img v-if="item.headIcon" class="tou_img1" :src="item.headIcon" @error="setfaultimg"
                                            alt="">
                                        <img class="tou_img2" src="../../assets/moveabout/fj/top1_1.png" alt="">
                                    </div>

                                    <div class="tou_name">
                                        <div>{{ item.roomName }}</div>
                                        <div class="tou_time"><img v-show="activation == 1"
                                                src="../../assets/moveabout/fj/time@3x.png" alt=""><img
                                                v-show="activation == 2" src="../../assets/moveabout/fj/diamond@2x.png"
                                                alt="">
                                            <span v-if="activation == 1" class="tiem_css">{{ formatSeconds(item.score)
                                            }}</span>
                                            <span v-else class="tiem_css">{{ item.score }}</span>
                                            <!-- <span class="tiem_css" v-show="activation == 1">{{ $t('Weekly_Cp.minute')
                                            }}</span> -->

                                        </div>
                                    </div>
                                </div>
                                <div class="touxiang">
                                    <div class="tou_box1">
                                        <img v-if="item.roomTops[0] && item.roomTops[0].headIcon" class="toux"
                                            :src="item.roomTops[0].headIcon" @error="setfaultimg" alt="">
                                        <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">
                                        <img class="icon1" src="../../assets/moveabout/fj/headtop1_1.png" alt="">

                                    </div>
                                    <div class="tou_box2">

                                        <img v-if="item.roomTops[1] && item.roomTops[1].headIcon" class="toux"
                                            :src="item.roomTops[1].headIcon" @error="setfaultimg" alt="">
                                        <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">

                                        <img class="icon2" src="../../assets/moveabout/fj/headtop2_1.png" alt="">

                                    </div>
                                    <div class="tou_box3">
                                        <img v-if="item.roomTops[2] && item.roomTops[2].headIcon" class="toux"
                                            :src="item.roomTops[2].headIcon" @error="setfaultimg" alt="">
                                        <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">

                                        <img class="icon3" src="../../assets/moveabout/fj/headtop3_1.png" alt="">

                                    </div>
                                </div>
                            </div>

                            <div v-if="item.top >= 2" :class="{ 'user_list': item.top == 2 }">
                                <div class="user-box">
                                    <div class="user-left">
                                        <img v-if="item.top == 2" class="user_icon"
                                            src="../../assets/moveabout/fj/top2@3x.png" alt="">
                                        <img v-if="item.top == 3" class="user_icon"
                                            src="../../assets/moveabout/fj/top3@3x.png" alt="">
                                        <span v-if="item.top > 3" class="paiming">{{ item.top }}</span>
                                        <img @click="languageRoomBtn(item)" v-if="item.headIcon" class="user_icon1"
                                            :src="item.headIcon" alt="" @error="setfaultimg">
                                        <img v-else class="user_icon1" src="../../assets/moveabout/fj/mo.png" alt="">
                                        <div class="user_name">
                                            <span>{{ item.roomName }}</span>
                                            <div class="user_time">
                                                <img v-show="activation == 1" src="../../assets/moveabout/fj/time@3x.png"
                                                    alt=""><img v-show="activation == 2"
                                                    src="../../assets/moveabout/fj/diamond.png" alt=""><span
                                                    v-if="activation == 1" class="tiem_css ft14">{{
                                                        formatSeconds(item.score) }}</span>
                                                <span v-else class="tiem_css">{{ item.score }}</span>
                                                <!-- <span class="tiem_css" v-show="activation == 1">{{ $t('Weekly_Cp.minute')
                                                }}</span> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="user-right">
                                        <div class="right-tou">
                                            <img v-if="item.roomTops[0] && item.roomTops[0].headIcon" class="toux"
                                                :src="item.roomTops[0].headIcon" alt="" @error="setfaultimg">
                                            <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">

                                            <img class="icon1" src="../../assets/moveabout/fj/headtop1_1.png" alt="">
                                        </div>
                                        <div class="right-tou1">
                                            <img v-if="item.roomTops[1] && item.roomTops[1].headIcon" class="toux"
                                                :src="item.roomTops[1].headIcon" alt="" @error="setfaultimg">
                                            <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">

                                            <img class="icon2" src="../../assets/moveabout/fj/headtop2_1.png" alt="">
                                        </div>
                                        <div class="right-tou2">
                                            <img v-if="item.roomTops[2] && item.roomTops[2].headIcon" class="toux"
                                                :src="item.roomTops[2].headIcon" alt="" @error="setfaultimg">
                                            <img v-else class="toux" src="../../assets/moveabout/fj/mo.png" alt="">

                                            <img class="icon3" src="../../assets/moveabout/fj/headtop3_1.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <van-loading v-show="staChange" type="spinner" color="#fff" vertical />
                    </div>
                    <div v-else>
                        <div v-if="this.activation == 1" class="guize">

                            <div class="award_box">
                                <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
                                <span class="award_txt">{{ $t('roomParty.top1') }}</span>
                                <div class="award_icon">
                                    <div class="icon_left">
                                        <div class="icon_box">
                                            <img :src="$t('roomParty.top1_pictures_1')" alt="">
                                        </div>
                                        <span class="txt">{{ $t('roomParty.top1_pictures_1_name') }}</span>
                                    </div>
                                    <div class="icon_left">
                                        <div class="icon_box">
                                            <img :src="$t('roomParty.top1_pictures_2')" alt="">
                                        </div>
                                        <span class="txt">{{ $t('roomParty.top1_pictures_2_name') }}</span>
                                    </div>

                                </div>
                                <!-- <div class="icon_bottom">
                                <div class="award_tao">
                                    <img :src="$t('Weekly_Cp.top1_pictures_3')" alt="">
                                    <img :src="$t('Weekly_Cp.top1_pictures_3')" alt="">
                                </div>
                                <span class="txt textshu mb15">{{ $t('Weekly_Cp.top1_pictures_34_name') }}</span>
                            </div> -->
                            </div>

                            <div class="award_box">
                                <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
                                <span class="award_txt1">{{ $t('roomParty.top2') }}</span>
                                <div class="award_icon">
                                    <div class="icon_left">
                                        <div class="icon_box">
                                            <img :src="$t('roomParty.top1_pictures_3')" alt="">
                                        </div>
                                        <span class="txt">{{ $t('roomParty.top1_pictures_1_name') }}</span>
                                    </div>
                                    <!-- <div class="icon_left">
                                    <div class="icon_box">
                                        <img :src="$t('Weekly_Cp.top2_pictures_2')" alt="">
                                    </div>
                                    <span class="txt textshu">{{ $t('Weekly_Cp.top1_pictures_2_name') }}</span>
                                </div> -->

                                </div>
                            </div>


                            <div class="award_box">
                                <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
                                <span class="award_txt1">{{ $t('roomParty.top3') }}</span>
                                <div class="award_icon">
                                    <div class="icon_left">
                                        <div class="icon_box">
                                            <img :src="$t('roomParty.top1_pictures_4')" alt="">
                                        </div>
                                        <span class="txt">{{ $t('roomParty.top1_pictures_4_name') }}</span>
                                    </div>
                                    <!-- <div class="icon_left">
                                    <div class="icon_box">
                                        <img :src="$t('Weekly_Cp.top3_pictures_2')" alt="">
                                    </div>
                                    <span class="txt textshu">{{ $t('Weekly_Cp.top1_pictures_2_name') }}</span>
                                </div> -->

                                </div>
                            </div>

                        </div>
                        <div v-if="this.activation == 2" class="guize" v-html="$t('roomParty.event_rule')">

                        </div>
                    </div>
                </div>


            </div>

        </div>



    </div>
</template>
    
    
<script>
import { Toast,Loading } from "vant";
import defImg from "../../assets/moveabout/fj/mo.png"
export default {
    name: "roomParty",
    components:{
        VanLoading: Loading,
    },
    data() {
        return {
            userInfo: [],
            userInfoData:{
                list:[],
                size:'',
                total:''
            },
            rulesInfo: '',
            startTime: '',
            endTime: '',
            startTimeAr: '',
            endTimeAr: '',
            startDate: '',
            endDate: '',
            activation: 1,
            btnStatus: false,
            previousPeriodSta: false,
            ruleAwardSta: false,
            awardStatus: false,
            // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOREV5IiwieHl6IjoiWmpsalpEUTVZakpqT0daaU5HTmlNV0ZpTnpWbFkyWmlNell3WmpnNVlqVT0iLCJleHAiOjE5MDc3NDM3NDB9.irA-gNwNYSD9s6_BQH2nwiQU8Zprq5BS2nyHhqwIRYY',
            // uid: 412,
            // headers: [
            //     'Content-Type:' + 'application/json; charset=utf-8',
            //     'deviceId:' + 'f9cd49b2c8fb4cb1ab75ecfb360f89b5',
            //     'lang:' + 'zh_CN',
            //     'version:' + '2.0.2',
            //     'os:' + '1',
            //     'model:' + 'M2011K2C',
            //     'fid:' + '0',
            //     'buyUser:' + '1',
            // ],
            token: null,
            uid: null,
            headers: null,
            //排行榜类型
            rankType: 1,
            //本轮1
            round: 1,
            //2周/1日
            type: 2,
            client: '',
            page: 0,
            size: 20,
            total: "",
            staChange: false,
            // 防止频繁请求
            notFast: true
        };
    },
    created() {
        this.$completes.complete("getUserInfo");
        window.getUserInfo = this.getUserInfo
        window['getUserInfo'] = (data) => {
            this.getUserInfo(data);
        }
        this.judgeClient()
        // this.getUserInfo();
    },
    mounted() {

    },
    methods: {
        returnTop() {
            this.$completes.complete("getPreviousPage");
        },

        getUserInfo(data) {
            let that = this
            this.userInfo = JSON.parse(data);
            this.headers = [
                'Content-Type:' + 'application/json; charset=utf-8',
                'deviceId:' + JSON.parse(data).deviceId,
                'lang:' + JSON.parse(data).lang,
                'version:' + JSON.parse(data).version,
                'os:' + JSON.parse(data).os,
                'model:' + JSON.parse(data).model,
                'fid:' + JSON.parse(data).fid
            ]
            this.token = JSON.parse(data).token
            this.uid = JSON.parse(data).userId
            let langs = this.userInfo.lang.substring(0, 2)
            let lang = this.userInfo.lang
            // let langs = 'zh'
            // let lang = ''
            if (langs == 'zh') {
                if (lang == 'zh_TW' || lang == 'zh_HK') {
                    this.$i18n.locale = 'tc'
                }
                else {
                    this.$i18n.locale = 'zh'
                }
            }
            else if (langs == 'en') {
                this.$i18n.locale = 'en'
            }
            else if (langs == 'ar') {
                this.$i18n.locale = 'ar'
            }
            else if (langs == 'tr') {
                this.$i18n.locale = 'tr'
            }else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "fr") {
              this.$i18n.locale = "fr"
            } else if (langs == "id") {
                this.$i18n.locale = "id"
            } else if (langs == "ms") {
                this.$i18n.locale = "ms"
            } else {
                this.$i18n.locale = 'en'
            }
            document.querySelector('html').setAttribute('lang', this.$i18n.locale);
            this.listData()
            this.rulesData()
        },

        ruleAwardBtn(code) {
            this.userInfoData.list = [];
            this.userInfo.size = "";
            this.userInfo.total = "";
            if (code == 1) {
                this.activation = 1;
                this.rankType = 1;
                this.page = 0;
                this.size = 20;
                this.listData();
            } else {
                this.page = 0;
                this.size = 20;
                this.activation = 2;
                this.rankType = 2;
                this.listData();
            }
        },
        awardBtn(code) {
            if (code == 1) {
                this.activation = 1;
            } else {
                this.activation = 2;

            }
        },
        previousPeriod(code) {
            this.userInfoData.list = [];
            if (code == 1) {
                this.previousPeriodSta = true;
                this.round = 2;
                this.listData()

            } else {
                this.round = 1;
                this.previousPeriodSta = false;
                this.ruleAwardSta = false;
                this.listData()

            }
            this.activation = 1;
        },

        setfaultimg(e) {
            e.target.src = defImg;
        },

        ruleAward() {
            this.ruleAwardSta = true;
            this.previousPeriodSta = true;
        },
        //跳转协议
        // languageRoomBtn(item) {
        //     let familyId = item.roomId;
        //     if (this.client == 'iOS') {
        //         window["webkit"].messageHandlers['languageRoom'].postMessage(JSON.stringify(familyId));

        //     } else if (this.client == 'Android') {
        //         nativeJs["languageRoom"](JSON.stringify(familyId));

        //     }
        // },

        judgeClient() {

            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                this.client = 'iOS';
            } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
                this.client = 'Android';
            } else {
                this.client = 'PC';
            }
            return this.client;
        },

        //分页
        pageScroll(e) {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = e.target.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = e.target.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = e.target.scrollHeight;
            var num = scrollTop + windowHeight;
            var heightNum = Math.ceil(num); 
            var heightNumtwo = Math.floor(num); 
            //滚动条到底部的条件
            if (heightNum == scrollHeight || heightNumtwo == scrollHeight) {
                if ( this.userInfoData.size == this.size ) {
                    // this.size = this.size + 10;
                    // this.listData();
                    if(this.notFast){
                        this.page++;
                        this.listData();
                    }
                }
            }
        },


        listData() {
            this.notFast = false;
            this.staChange = true;
            let that = this
            let paramObjs = {
                option: 'get',
                host: this.$serviceIp + '/api/activity/rank/room/page?token=' + that.token + '&uid=' + that.uid + '&rankType=' + that.rankType + '&round=' + that.round + '&type=' + that.type + '&page=' +that.page +'&size=' +that.size,
                data: '',
                header: JSON.stringify(this.headers),
            };
            this.$server.curlExec(paramObjs).then((data) => {
                if (data.code == 200) {
                    console.log(data);
                    // this.userInfoData = data.data;
                        this.userInfoData.list.push(...data.data.list)
                        this.userInfoData.size = data.data.size;
                        this.userInfoData.total = data.data.total;
                        if(data.data.size == data.data.length) {
                            this.notFast = true;
                        }

                    this.total = data.data.total;
                    this.staChange = false;
                }
                else {
                    Toast(data.message || this.$t('transfer.error'))
                }

            })
        },



        rulesData() {
            let that = this
            let paramObjs = {
                option: 'get',
                host: this.$serviceIp + '/api/activity/rank/index?token=' + that.token + '&uid=' + that.uid + '&rankType=' + that.rankType,
                data: '',
                header: JSON.stringify(this.headers),
            };
            this.$server.curlExec(paramObjs).then((data) => {
                if (data.code == 200) {
                    console.log(data);
                    this.rulesInfo = data.data;
                    this.startTime = data.data.startTime;
                    this.endTime = data.data.endTime;

                    this.startTimeAr = data.data.startTime.slice(10);
                    this.endTimeAr = data.data.endTime.slice(10);
                    this.startDate = data.data.startTime.slice(0, 10);
                    this.endDate = data.data.endTime.slice(0, 10);

                }
                else {
                    Toast(data.message || this.$t('transfer.error'))
                }

            })
        },


        formatSeconds(value) {
            let theTime1 = value;
            let theTime2 = Math.ceil(Number(theTime1 / 60))
            console.log(theTime2);
            return theTime2;
        }
    },



};

</script>
    
<style scoped>
* {
    margin: 0;
    padding: 0;
}

.text-right {
    height: 100%;
    background: #8736AB;
    /* display: flex;
        flex-direction: column; */
}

.head {
    width: 100%;
    /* height: 40%;
    background: url("../../assets/moveabout/fj/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    position: relative;
}

.head-img {
    width: 100%;
}

.title {
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -50%);
}

.title img {
        width: 263px;
    height: 57px;
}

.title-left {
    min-width: 80px;
    padding: 0px 2px;
    position: absolute;
    left: 0;
    top: 44%;
    background: linear-gradient(0deg, #FE00B9, #841AF0);
    box-shadow: -1px -1px 11px 2px rgba(37, 34, 171, 0.74), -2px 3px 15px 1px rgba(255, 234, 0, 0.54);
    border-radius: 2px 23px 23px 2px;
}

.title-left1 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    border-radius: 2px 23px 23px 2px;
    background: url("../../assets/moveabout/fj/button_left@3x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    left: 0;
    top: 59%;
}

.back_img {
    height: 24px;
    margin-right: 3px;
    /* margin-left: 4px; */
}

.title-left,
.title-left1 {
    height: 33px;
    font-size: 14px;
    line-height: 33px;
    padding: 0px 5px;
    text-align: center;
    color: #fff;
    /* background: linear-gradient(0deg, #FE00B9, #841AF0);
box-shadow: -1px -1px 11px 2px rgba(37,34,171,0.74), -2px 3px 15px 1px rgba(255,234,0,0.54);
border-radius: 2px 23px 23px 2px; */


}

html[lang="ar"] .title-left {
    direction: rtl;
    unicode-bidi: bidi-override;
}

html[lang="ar"] .title-left1 {
    direction: rtl;
    unicode-bidi: bidi-override;
}

.body {
    min-height: 600px;
    /* height: 600px; */
    margin: 0 auto;
    /* background: #8736AB; */
    background: linear-gradient(0deg, #7C32A4, #8736AB);
    position: relative;
    top: -9%;
}

.body_text {
    font-size: 20px;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FEFEFE;
    line-height: 40px;
    margin-bottom: 20px;
}

.head_btn {
    width: 70%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 50%;
    top: 80%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.body-top {
    width: 94%;
    /* min-height: 1400px; */
    box-sizing: border-box;
    margin: 0 auto;
    background: url("../../assets/moveabout/fj/topfraright.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 45px 17px;
    padding-top: 45px;
    padding-bottom: 80px;

    /* overflow-y: scroll; */
}

.minbody {
    height: 1200px;
    padding-top: 30px;
    padding-bottom: 60px;
    overflow-y: scroll;
}

.time_diamond {
    width: 120px;
    height: 40px;
    color: #fff;
    box-shadow: -1px -1px 11px 2px rgba(177, 56, 246, 0.45), -2px 3px 9px 0px rgba(249, 76, 255, 0.21);
    border-radius: 32px;
    padding: 0 5px;
    text-align: center;
    font-size: 15px;
    background: url("../../assets/moveabout/fj/button_nor@3x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;

}

html[lang="ar"] .time_diamond {
    direction: rtl;
    unicode-bidi: bidi-override;
}

.activation_bg {
    background: url("../../assets/moveabout/fj/button_select@3x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: center;
}

.time {
    color: #fff;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
}

/* html[lang="ar"] .time span {
  direction: rtl;
  unicode-bidi: bidi-override;
  } */

.tou {
    height: 100px;
    /* display: flex;
    align-items: center; */
    position: relative;
    margin-top: 20px;
}

/* html[lang="ar"] .tou {
  direction: rtl;
  unicode-bidi: bidi-override;
  } */

.tou_img {
    width: 100px;
    height: 100px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

}

.tou_top1 {
    width: 164px;
    height: 164px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url("../../assets/moveabout/fj/headbg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.tou_img2 {
    width: 98px;
    /* height: 84px; */
    border-radius: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.tou_img1 {
    width: 64px;
    /* height: 68px; */
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
}

.tou_name {
    width: 200px;
    font-size: 16px;
    color: #ffff;
    line-height: 25px;
    position: absolute;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    left: 50%;
    top: 120%;
    transform: translate(-50%, -50%);
}

/* html[lang="ar"]  .tou_name{
    direction: rtl;
  unicode-bidi: bidi-override;
  } */

.tou_time {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tou_time span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tou_name img {
    width: 20px;
    margin-right: 3px;
    /* height: 18px; */
}

html[lang="ar"] .tou_name img {
    width: 20px;
    margin-left: 3px;
}

.toux {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid #FAEC0F;
}

.icon1,
.icon2,
.icon3 {
    width: 20px;
    /* height: 16px; */
}

.icon1 {
    position: absolute;
    left: 72%;
    top: 3%;
    transform: translate(-50%, -50%);
}

.icon2 {
    position: absolute;
    left: 75%;
    top: 3%;
    transform: translate(-50%, -50%);
}

.icon3 {
    position: absolute;
    left: 78%;
    top: 3%;
    transform: translate(-50%, -50%);
}

.touxiang {
    height: 100px;
    position: relative;
}


.tou_box1 {
    display: flex;
    position: absolute;
    left: 75%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

}

.tou_box2 {
    display: flex;

    position: absolute;
    left: 83%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

}

.tou_box3 {
    display: flex;

    position: absolute;
    left: 92%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
}

html[lang="ar"] .tou_box1 {
    position: absolute;
    left: 25%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}

html[lang="ar"] .tou_box2 {
    position: absolute;
    left: 16%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

}

html[lang="ar"] .tou_box3 {
    position: absolute;
    left: 7%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
}

.user_list {
    margin-top: 60px;
}

.user-box {
    height: 85px;
    display: flex;
}

html[lang="ar"] .user-box {
    direction: rtl;
    unicode-bidi: bidi-override;
}

.user-left {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.paiming {
    width: 30px;
    height: 40px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.6;
    line-height: 40px;
}

.user_icon {
    /* width: 30px; */
    height: 40px;
}

.user_icon1 {
    width: 70px;
    height: 70px;
    border-radius: 10px;
}

.guize {
    font-size: 15px;
    color: #fff;
    line-height: 30px;
    padding: 0 10px;
    padding-bottom: 30px;
}

.guize p {
    margin-bottom: 10px;
}

html[lang="ar"] .guize {
    direction: rtl;
    unicode-bidi: bidi-override;
}


.user_name {
    width: 85px;
    font-size: 16px;
    color: #fff;
    line-height: 25px;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* html[lang="ar"] .user_name span{
  direction: rtl;
  unicode-bidi: bidi-override;
  } */

.user_name span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user_name img {
    width: 20px;
    /* height: 18px; */
    margin-right: 3px;
}

html[lang="ar"] .user_name img {
    width: 20px;
    margin-left: 3px;
}

.user_time {
    display: flex;
    align-items: center;
}

html[lang="ar"] .user_time {
    direction: rtl;
    unicode-bidi: bidi-override;
}

.user_time span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-right {
    flex: 1;
    position: relative;
}

.right-tou {
    display: flex;
    position: absolute;
    left: 35%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}

.right-tou1 {
    display: flex;
    position: absolute;
    left: 56%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.right-tou2 {
    display: flex;
    position: absolute;
    left: 78%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
}


.award_txt {
    font-family: Montserrat;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 5px 0px rgb(124 9 37 / 66%);
    position: absolute;
    left: 50%;
    top: -5%;
    transform: translate(-50%, -50%);
}

html[lang="ar"] .award_txt {
    direction: rtl;
    unicode-bidi: bidi-override;
}






.ft16 {
    font-size: 16px;
}

.ft15 {
    font-size: 14px;
}

.ft14 {
    font-size: 14px;
}


.ft18 {
    font-size: 18px;
}

.tiem_css {
    font-size: 14px;
    font-family: Lantinghei SC;
    font-weight: 200;
    color: #FFFFFF;
    opacity: 0.6;
}

/* ------------------------------------------- */
.award_box {
    width: 94%;
    /* height: 300px; */
    margin: 0 auto;
    margin-top: 48px;
    background: #fff;
    border-radius: 15px;
    position: relative;
}

html[lang="ar"] .award_box {
    direction: rtl;
    unicode-bidi: bidi-override;
}


.award_img {
    width: 320px;
    height: 70px;
    position: absolute;
    left: 50%;
    top: 2%;
    transform: translate(-50%, -50%);
}

.award_txt1 {
    font-family: Montserrat;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 5px 0px rgb(124 9 37 / 66%);
    position: absolute;
    left: 50%;
    top: -7%;
    transform: translate(-50%, -50%);
}

.award_icon {
    width: 270px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
}

.icon_left {
    margin-top: 45px;
    margin-bottom: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.icon_left span {
    width: 112px;
    word-wrap: break-word;
    text-align: center;
    line-height: 20px;
}

.txt {
    font-family: PingFang SC;
    font-weight: 400;
    color: #000000;
}

.textshu {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.icon_box {
    width: 120px;
    height: 120px;
    background: #ECE6FD;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;

}

.icon_box img {
    width: 83px;
    height: 83px;
}

.icon_bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.award_tao {
    width: 270px;
    height: 142px;
    background: #ECE6FD;
    margin: 0 auto;
    border-radius: 15px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.award_tao img {
    width: 83px;
    height: 83px;
}

.icon_bottom span {
    width: 270px;
    height: 30px;
    text-align: center;
    line-height: 30px;
}

.tou-top {
    color: #000;
    width: 100%;
    /* height: 45px; */
    background: #fff;
    padding-top: 44px;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
}

html[lang="ar"] .tou-top {
    -webkit-transform: rotateY(180deg);
}

.head-top{
    position: relative;

}

.returns {
    position: absolute;
    width: 25px;
    height: 25px;
    left: 0;
    top: 0;
}

.head {
    margin-top: 89px;
}


.tou-top p {
    font-size: 18px;
    line-height: 25px;
    text-align: center;
}
</style>